import React, { Component, Fragment } from 'react';
import {
    Card,
    Button,
    Form,
    Collapse,
    InputNumber,
    Empty,
    Icon,
    Alert,
    Col,
    Row,
    Select
} from 'antd';
import { IndicatorGroup } from './IndicatorGroup';
import { toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
const Option = Select.Option;
const Panel = Collapse.Panel;

@inject('store')
@observer
export class IndicatorManager extends Component {
    handleGroupUpdate(idx, config) {
        const { form, mode } = this.props;
        let groups = toJS(form.getFieldValue(`${mode}_groups`));
        groups[idx] = config;
        form.setFieldsValue({
            [`${mode}_groups`]: groups
        });
    }

    handleRemoveGroup(idx) {
        console.log(idx);
        const { form, mode } = this.props;
        let groups = toJS(form.getFieldValue(`${mode}_groups`));
        groups.splice(idx, 1);
        form.setFieldsValue({
            [`${mode}_groups`]: groups
        });
    }

    handleClone(idx) {
        console.log(idx);
        const { form, mode } = this.props;
        let groups = toJS(form.getFieldValue(`${mode}_groups`));
        const source = toJS(groups[idx]);
        let group = { ...source, _id: Date.now(), name: `${source.name} (Cloned ${idx + 1})` };

        groups.push(group);
        form.setFieldsValue({
            [`${mode}_groups`]: groups
        });
    }

    render() {
        const { mode, enabled } = this.props;
        const { getFieldValue, getFieldDecorator } = this.props.form;

        getFieldDecorator(`${mode}_groups`, { initialValue: [] });

        const artMode = getFieldValue(`${mode}_mode`);
        if (!enabled) {
            return null;
        }

        if (this.props.art && artMode === 'auto_sell') {
            return (
                <Fragment>
                    <Row gutter={24}>
                        <Col md={24}>
                            <Alert
                                message="Please note: Due to the nature of ART, 'Apex Auto Sell' will sell for a loss. Using this you agree Apex is not responsible for any loss of funds when using this feature."
                                type="warning"
                                showIcon
                            />
                        </Col>
                        {this.renderType()}
                        {this.renderAutoSell()}
                    </Row>
                </Fragment>
            );
        }

        return (
            <Fragment>
                <Row gutter={24}>
                    {this.renderType()}
                    {this.renderThreshold()}
                </Row>

                {this.renderIndicators()}
            </Fragment>
        );
    }

    renderIndicators() {
        const { mode, meta } = this.props;
        const { getFieldValue } = this.props.form;

        const groups = getFieldValue(`${mode}_groups`);

        const customPanelStyle = {
            background: '#2c25482e',
            borderRadius: 4,
            marginBottom: 15,
            border: 0,
            overflow: 'hidden'
        };

        if (meta) {
            if (
                meta.hide_indicators &&
                meta.author_id !== this.props.store.userStore.currentUser.uid
            ) {
                return (
                    <Card title={`Indicators & Signals`} size={'small'} style={{ marginTop: 15 }}>
                        <Alert
                            message="The author has restricted the ability to view and modify indicators"
                            type="warning"
                            icon={<Icon type="lock" />}
                            showIcon
                        />
                    </Card>
                );
            }
        }

        return (
            <Card
                title={`Indicators & Signals`}
                size={'small'}
                extra={
                    <Button
                        type="primary"
                        onClick={() => {
                            const { form } = this.props;
                            const buyGroup = form.getFieldValue(`${mode}_groups`);
                            const nextIndicators = buyGroup.concat({
                                name: `Untitled group`,
                                concensus: 1,
                                signal_price: 'last_tick',
                                indicators: [],
                                signals: []
                            });
                            form.setFieldsValue({
                                [`${mode}_groups`]: nextIndicators
                            });
                        }}
                    >
                        Add Group
                    </Button>
                }
                style={{ marginTop: 15 }}
            >
                {!groups.length ? (
                    <Empty description={'Add a group to add indicators and signals'} />
                ) : (
                    <Collapse
                        expandIcon={({ isActive }) => (
                            <Icon type="caret-right" rotate={isActive ? 90 : 0} />
                        )}
                        bordered={false}
                    >
                        {groups.map((group, i) => {
                            if (!group._id) group._id = Date.now();
                            return (
                                <Panel header={group.name} key={group._id} style={customPanelStyle}>
                                    <IndicatorGroup
                                        idx={i}
                                        onClone={this.handleClone.bind(this, i)}
                                        onGroupUpdate={this.handleGroupUpdate.bind(this, i)}
                                        onRemoveGroup={this.handleRemoveGroup.bind(this, i)}
                                        group={group}
                                        signalPrice={this.props.signalPrice}
                                    />
                                </Panel>
                            );
                        })}
                    </Collapse>
                )}
            </Card>
        );
    }

    renderType() {
        const { getFieldDecorator } = this.props.form;
        const { mode } = this.props;

        if (this.props.art) {
            return (
                <Col md={6} style={{ paddingLeft: 12, paddingRight: 12 }}>
                    <Form.Item label={'Mode'}>
                        {getFieldDecorator(`${mode}_mode`, {
                            initialValue: 'indicators'
                        })(
                            <Select>
                                <Option value={'indicators'}>Indicators & Signals</Option>
                                <Option value={'auto_sell'}>Apex Auto Sell</Option>
                            </Select>
                        )}
                    </Form.Item>
                </Col>
            );
        }
    }

    renderThreshold() {
        const { getFieldDecorator, getFieldValue } = this.props.form;
        const { mode } = this.props;
        const artMode = getFieldValue(`${mode}_mode`);

        if (artMode === 'indicators') {
            return (
                <Col md={6} style={{ paddingLeft: 12, paddingRight: 12 }}>
                    <Form.Item
                        label={'Minimum Threshold'}
                        extra={'ART will wait for a position to drop x%'}
                    >
                        {getFieldDecorator(`${mode}_threshold`, {
                            initialValue: 5
                        })(<InputNumber />)}
                    </Form.Item>
                </Col>
            );
        }

        return null;
    }

    renderAutoSell() {
        const { getFieldDecorator, getFieldValue } = this.props.form;
        const { mode } = this.props;
        const artMode = getFieldValue(`${mode}_mode`);
        if (artMode === 'auto_sell') {
            return (
                <Fragment>
                    {
                        <Col md={4} style={{ paddingLeft: 12, paddingRight: 12 }}>
                            <Form.Item
                                label={'Period'}
                                extra={'Choose a period which suits your buy strategy'}
                            >
                                {getFieldDecorator(`${mode}_auto_sell_period`, {
                                    initialValue: '15m'
                                })(
                                    <Select>
                                        <Option value={'1m'}>1m</Option>
                                        <Option value={'3m'}>3m</Option>
                                        <Option value={'5m'}>5m</Option>
                                        <Option value={'15m'}>15m</Option>
                                        <Option value={'30m'}>30m</Option>
                                        <Option value={'1h'}>1h</Option>
                                        <Option value={'2h'}>2h</Option>
                                        <Option value={'4h'}>4h</Option>
                                        <Option value={'12h'}>12h</Option>
                                        <Option value={'1d'}>1d</Option>
                                        <Option value={'3d'}>3d</Option>
                                    </Select>
                                )}
                            </Form.Item>
                        </Col>
                    }
                </Fragment>
            );
        }

        return null;
    }
}



// WEBPACK FOOTER //
// ./src/Account/Strategies/Shared/IndicatorManager/index.js